export default "__VITE_ASSET__D6U7X1oU__"